<template>
    <div>
        <v-dialog
            width="750"
            v-model="display">
            <v-card>
                <v-card-title>{{$t("mileage_readings")}}</v-card-title>
                <v-card-text>
                    <v-skeleton-loader type="table" v-if="loading.data"></v-skeleton-loader>
                    <v-simple-table dense v-if="!loading.data">
                        <tbody>
                            <tr>
                                <th>{{$t("date")}}</th>
                                <td>{{mileageReading.date}}</td>
                            </tr>
                            <tr>
                                <th>{{$t("truck_type")}}</th>
                                <td>{{mileageReading.truck_type}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table> 
                    <v-simple-table dense v-if="!loading.data" class="mt-4">
                        <thead>
                            <tr>
                                <td>{{$t("plate_number")}}</td>
                                <td>{{$t("truck_type")}}</td>
                                <td>{{$t("distance_km")}}</td>
                                <td>{{$t("remarks")}}</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="line in mileageReading.lines" :key="line.id">
                                <td>{{line.plate_number}}</td>
                                <td>{{line.truck_type}}</td>
                                <td>{{line.distance}}</td>
                                <td>{{line.remarks}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn  
                        text
                        @click="close">
                        close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AlertDialog from '../components/AlertDialog';

export default {
    name: "MileageReadingDisplayDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            display: false,
            loading: {
                data: false
            }
        }
    },
    computed: {
        ...mapState("mileageReading", ["mileageReading"])
    },
    methods: {
        ...mapActions("mileageReading", ["fetchMileageReading"]),
        open({id}) {
            this.display = true;
            this.openParams = {id};
            this.openDataFetch();
        },
        async openDataFetch() {
            try {
                this.loading.data = true;
                await this.fetchMileageReading(this.openParams.id);
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.alertDialog.open(this.$t("ALERT_TITLE_WARNING"), message);
            }
        },
        close() {
            this.display = false;
        }
    }
}
</script>